module.exports = __webpack_public_path__ + "static/media/serena-lose.e20073a2.png";